export const HOME = {
  emergentLink: "emergent-link",
};

export const LANDING = {
  page: "landing-page",
  topbar: "topbar",
  header: "header",
  logo: "logo",
  logoImg: "logo-img",
  langSelect: "lang-select",
  navMonthlyOffers: "nav-monthly-offers",
  navRegister: "nav-register",
  navDraw: "nav-exclusive-draw",
  navMaps: "nav-store-maps",
  navContact: "nav-contact",
  mobileMenuBtn: "mobile-menu-btn",
  mobileMenuSheet: "mobile-menu-sheet",
  adminTextLink: "admin-text-link",
  specialBanner: "special-offer-banner",
  bannerAdsLoop: "banner-ads-loop",
  departuresCarousel: "departures-carousel",
  arrivalsCarousel: "arrivals-carousel",
  promoThumbDepartures: "promo-thumb-departures",
  promoThumbArrivals: "promo-thumb-arrivals",
  locationHeader: "location-header",
  categoryFilter: "category-filter",
  categoryBtn: "category-btn",
  productGrid: "product-grid",
  productCard: "product-card",
  productDialog: "product-dialog",
  shopMapCarousel: "shop-map-carousel",
  registerWidget: "register-widget",
  registerOverlayBtn: "register-overlay-btn",
  drawCardMillennium: "draw-card-millennium",
  drawCardLuxury: "draw-card-luxury",
  drawCardMotorcycle: "draw-card-motorcycle",
  contactDialog: "contact-dialog",
  socialFb: "social-fb",
  socialTw: "social-tw",
  socialIg: "social-ig",
  socialTt: "social-tt",
  socialWeibo: "social-weibo",
  socialWechat: "social-wechat",
  footer: "footer",
};

export const ADMIN = {
  loginDialog: "admin-login-dialog",
  loginEmail: "admin-login-email",
  loginPwdField: "admin-login-pwd-field",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",
  panel: "admin-panel",
  logoutBtn: "admin-logout-btn",
  logoUpload: "admin-logo-upload",
  saveLogoBtn: "admin-save-logo-btn",
  bannerUpload: "admin-banner-upload",
  saveBannerBtn: "admin-save-banner-btn",
  bgColor: "admin-bg-color",
  textColor: "admin-text-color",
  barColor: "admin-bar-color",
  saveStyleBtn: "admin-save-style-btn",
  adUpload: "admin-ad-upload",
  addAdBtn: "admin-add-ad-btn",
  adsList: "admin-ads-list",
  mapUpload: "admin-map-upload",
  addMapBtn: "admin-add-map-btn",
  mapsList: "admin-maps-list",
  millImg: "admin-mill-img",
  luxCarImg: "admin-lux-car-img",
  motoImg: "admin-moto-img",
  millLink: "admin-mill-link",
  luxCarLink: "admin-lux-car-link",
  motoLink: "admin-moto-link",
  savePrizeImgs: "admin-save-prize-imgs",
  registerLink: "admin-register-link",
  registerMedia: "admin-register-media",
  saveRegisterBtn: "admin-save-register-btn",
  promoLocSelect: "admin-promo-loc-select",
  promoName: "admin-promo-name",
  promoCat: "admin-promo-cat",
  promoDesc: "admin-promo-desc",
  promoHeader: "admin-promo-header",
  promoPrice: "admin-promo-price",
  promoImage: "admin-promo-image",
  addPromoItemBtn: "admin-add-promo-item-btn",
  promoItemsList: "admin-promo-items-list",
  editPromoBtn: "admin-edit-promo-btn",
  deletePromoBtn: "admin-delete-promo-btn",
  savePromoData: "admin-save-promo-data",
  contactPhone: "admin-contact-phone",
  contactTollFree: "admin-contact-tollfree",
  contactEmail: "admin-contact-email",
  saveContactBtn: "admin-save-contact-btn",
};
